import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "@/components/pages/home";
import { Expenses } from "@/components/pages/expenses";
import { QuestionPage } from "@/components/pages/questionPage";
import { ResultPage } from "@/components/pages/resultPage";
import { Header } from '@/components/header';
import { Footer } from '@/components/footer';

export const RouteConfig =() => {
  return (
    <>
     <BrowserRouter basename="/dx/">
     <Header />
      <Routes>
        <Route index element={<Home />} />
        <Route path="quesation" element={<QuestionPage />} />
        <Route path="result" element={<ResultPage />} />
      </Routes>
     <Footer />
    </BrowserRouter>
    <BrowserRouter basename="/dx/expenses/">
        <Routes>
            <Route index element={<Expenses/>} />
            <Route path="quesation" element={<QuestionPage />} />
            <Route path="result" element={<ResultPage />} />
        </Routes>
        <Footer />
    </BrowserRouter>
    </>
  );
}